import { render, staticRenderFns } from "./TrackingAlert.vue?vue&type=template&id=aa15b56a"
import script from "./TrackingAlert.vue?vue&type=script&lang=js"
export * from "./TrackingAlert.vue?vue&type=script&lang=js"
import style0 from "./TrackingAlert.vue?vue&type=style&index=0&id=aa15b56a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports